import { fileTypesEnum } from "../../../../enums/errors/accounts/general/fileTypes.enum";
import FileInputElementComponent from "../../../general/elements/inputElements/FileInputElementComponent";

export const WebsiteConfigurationAboutImageSection = ({ props }) => {
  const { currentValue, handleChange } = props;

  const getHomeAboutBackgroundImageInputsElement = () => {
    const inputProps = {
      label: "תמונת רקע",
      name: "BackgroundImage",
      value: currentValue.Url,
      fileType: fileTypesEnum.image,
      onChange: handleChange,
    };
    return <FileInputElementComponent props={inputProps} />;
  };

  return getHomeAboutBackgroundImageInputsElement();
};

export default WebsiteConfigurationAboutImageSection;
